<template>
	<div v-if="usePortalAuthEnabled">
		<MaybeUpgradeRequiredIndicator :billingFeatureId="billingFeatureId">
			<template #default="{ indicator, isUpgradeRequired }">
				<Row>
					<div class="title-text mb-1">Authentication</div>
					<component class="ml-2" :is="indicator" :billingFeatureId="billingFeatureId" canBuild v-if="isUpgradeRequired" />
				</Row>
			</template>
		</MaybeUpgradeRequiredIndicator>
		<Row>
			<Col> Enable authentication </Col>
			<Col>
				<AppSwitch class="swtch sml" v-model="localSettings.customer_auth_enabled" />
			</Col>
		</Row>
		<Row
			><p>
				With authentication enabled, you will need a verification code to log in. Select your preferred method for receiving a verification
				code.
			</p></Row
		>
		<div v-if="localSettings.customer_auth_enabled">
			<AppRadioButton v-model="localSettings.customer_auth_method" :choices="authMethods">
				<template v-slot:label="{ item }">
					<div class="label">
						{{ item.title }}<span class="ml-1 sub-label">{{ item.subTitle }}</span>
					</div>
				</template>
			</AppRadioButton>

			<AppTextArea
				v-model="localSettings.customer_auth_text"
				label="This is what your users will see when prompted to authenticate."
				outlined
			/>
		</div>
	</div>
</template>

<script>
import MaybeUpgradeRequiredIndicator from '@/components/Billing/MaybeUpgradeRequiredIndicator.vue';
import { FeatureTypes } from '@/components/Billing/billing-types';
import { usePortalAuthEnabled } from '@/store/modules/featureFlags/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'PortalAuthSettingsContent',
	components: { MaybeUpgradeRequiredIndicator },
	props: {
		settings: { type: Object, required: true },
	},
	computed: {
		...mapGettersShorthand({ usePortalAuthEnabled }),
		billingFeatureId() {
			return FeatureTypes.CustomerAuthEmailSignIn;
		},
		authMethods() {
			return [
				/*
				{
					title: `SMS verification:`,
					subTitle: `A code will be sent to the customers number.`,
					value: 'sms',
				},
				*/
				{
					title: `Email verification:`,
					subTitle: 'A code will be sent to customer address.',
					value: 'email',
					selected: true,
				},
			];
		},
	},
	methods: {
		async emitSettingsUpdated() {
			this.$emit('settings-updated', this.localSettings);
		},
	},
	created() {
		this.localSettings = JSON.parse(JSON.stringify(this.settings));
	},
	data() {
		return {
			localSettings: {},
		};
	},
	watch: {
		localSettings: {
			handler(v) {
				this.$emit('update:settings', v);
			},
			deep: true,
		},
	},
};
</script>

<style scoped lang="scss">
.title-text {
	font-size: 18px;
	font-weight: 600;
	text-align: left;
	color: var(--primary-font-color);
}
.dialog-content {
	width: 620px;
	height: 655px;
	border-radius: 10px;
	background: #ffffff;
}
.save-button {
	width: 140px !important;
	height: 45px !important;
	font-size: 14px !important;
	color: #ffffff !important;
	font-weight: 400 !important;
	letter-spacing: 0px !important;
	border-radius: 10px !important;
	text-transform: none !important;
	background: #5858ec !important;
	border: 1px solid #5858ec !important;
	&:disabled {
		border: unset !important;
	}
}
</style>
